import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

const CSS_Description_List = () => {
  return (
    <div className="tutorial-container">
      <h1 className="tutorial-title">📝 CSS Description Lists</h1>

      <p className="tutorial-intro">
        A <code>&lt;dl&gt;</code> (description list) is used to group terms and
        their descriptions. Each term is wrapped in <code>&lt;dt&gt;</code>{" "}
        (definition term), and each description is wrapped in{" "}
        <code>&lt;dd&gt;</code> (definition description). CSS allows you to
        style them for better readability and design.
      </p>

      {/* Section 1 */}
      <div className="tutorial-section">
        <h2 className="section-title">🔹 Default Description List</h2>
        <p>
          By default, description lists show terms on one line and their
          descriptions indented on the next:
        </p>

        <CodeCopyBlock
          code={`<dl>
  <dt>HTML</dt>
  <dd>A markup language for structuring web content.</dd>

  <dt>CSS</dt>
  <dd>A stylesheet language used to style HTML documents.</dd>

  <dt>JavaScript</dt>
  <dd>A programming language for web interactivity.</dd>
</dl>`}
        />

        <div style={{ marginTop: "1rem" }}>
          <dl
            style={{
              background: "#f0fdf4",
              padding: "15px 30px",
              borderRadius: "8px",
              border: "1px solid #bbf7d0",
            }}
          >
            <dt style={{ fontWeight: "bold", color: "#166534" }}>HTML</dt>
            <dd>A markup language for structuring web content.</dd>

            <dt style={{ fontWeight: "bold", color: "#166534" }}>CSS</dt>
            <dd>A stylesheet language used to style HTML documents.</dd>

            <dt style={{ fontWeight: "bold", color: "#166534" }}>JavaScript</dt>
            <dd>A programming language for web interactivity.</dd>
          </dl>
        </div>
      </div>

      {/* Section 2 */}
      <div className="tutorial-section">
        <h2 className="section-title">🔹 Styling Description Lists</h2>
        <p>
          You can use CSS to style terms and descriptions separately for better
          design:
        </p>

        <CodeCopyBlock
          code={`dl {
  background: #f9fafb;
  padding: 20px;
  border-radius: 8px;
}

dt {
  font-weight: bold;
  color: #2563eb;
  margin-top: 10px;
}

dd {
  margin-left: 20px;
  color: #374151;
  font-style: italic;
}`}
        />

        <div style={{ marginTop: "1rem" }}>
          <dl
            style={{
              background: "#eff6ff",
              padding: "15px 30px",
              borderRadius: "8px",
              border: "1px solid #bfdbfe",
            }}
          >
            <dt style={{ fontWeight: "bold", color: "#2563eb" }}>Frontend</dt>
            <dd style={{ marginLeft: "20px", fontStyle: "italic" }}>
              HTML, CSS, and JavaScript.
            </dd>

            <dt style={{ fontWeight: "bold", color: "#2563eb" }}>Backend</dt>
            <dd style={{ marginLeft: "20px", fontStyle: "italic" }}>
              Node.js, Python, PHP, and databases.
            </dd>
          </dl>
        </div>
      </div>

      {/* Section 3 */}
      <div className="tutorial-section">
        <h2 className="section-title">🔹 Nested Description Lists</h2>
        <p>
          You can also nest description lists to organize content more clearly:
        </p>

        <CodeCopyBlock
          code={`<dl>
  <dt>Web Development</dt>
  <dd>
    <dl>
      <dt>Frontend</dt>
      <dd>HTML, CSS, JavaScript</dd>

      <dt>Backend</dt>
      <dd>Node.js, PHP, Python</dd>
    </dl>
  </dd>
</dl>`}
        />

        <div style={{ marginTop: "1rem" }}>
          <dl
            style={{
              background: "#faf5ff",
              padding: "15px 30px",
              borderRadius: "8px",
              border: "1px solid #e9d5ff",
              color: "#6b21a8",
            }}
          >
            <dt style={{ fontWeight: "bold" }}>Web Development</dt>
            <dd>
              <dl
                style={{
                  marginTop: "8px",
                  paddingLeft: "20px",
                  color: "#9333ea",
                }}
              >
                <dt style={{ fontWeight: "bold" }}>Frontend</dt>
                <dd>HTML, CSS, JavaScript</dd>

                <dt style={{ fontWeight: "bold" }}>Backend</dt>
                <dd>Node.js, PHP, Python</dd>
              </dl>
            </dd>
          </dl>
        </div>
      </div>
    </div>
  );
};

export default CSS_Description_List;
